import { render, staticRenderFns } from "./selectpests.vue?vue&type=template&id=107712dc&scoped=true&"
import script from "./selectpests.vue?vue&type=script&lang=js&"
export * from "./selectpests.vue?vue&type=script&lang=js&"
import style0 from "./selectpests.vue?vue&type=style&index=0&id=107712dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107712dc",
  null
  
)

export default component.exports